export enum ActivityType {
    FEED = 'FEED',
    GAMES = 'GAMES',
    VIDEOS = 'VIDEOS',
    HOBBY = 'HOBBY',
    MESSAGES = 'MESSAGES',
    OTHER = 'OTHER',
    PLAYER = 'PLAYER'
}

export enum ActivityId {
    FEED = 32,
    GAMES = 34,
    VIDEOS = 33,
    HOBBY = 79,
    MESSAGES = 37,
    OTHER = 36,
    PLAYER = 35
}

export type ActivityMap<K extends string | number | symbol = string, V = string> = Record<K, V[]>;

export interface ITimespentTrackerEvent {
    type: string;
    id: number;
    activity: ActivityId;
    canUseInBackground?: boolean;
}